import { render } from "./callCenterSettings.vue?vue&type=template&id=5be3aa8e&scoped=true"
import script from "./callCenterSettings.vue?vue&type=script&lang=js"
export * from "./callCenterSettings.vue?vue&type=script&lang=js"

import "./callCenterSettings.vue?vue&type=style&index=0&id=5be3aa8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be3aa8e"]])

export default __exports__